import { callDeepSeekApi } from './AIUtils';
import { parseLlmJson } from './parseLlmJson';

const DICTIONARY_JSON_EXAMPLE = JSON.stringify(
    {
        chineseExplanation: '詞性、釋義及簡短例句（繁體中文）',
        englishExplanation: 'Part of speech, meaning, and a brief example if helpful',
    },
    null,
    2
);

export function buildAiDictionaryPrompt(text) {
    const trimmed = (text || '').trim();
    return [
        'You are a concise bilingual dictionary assistant.',
        `Explain the word or phrase: "${trimmed}"`,
        'Provide a clear dictionary-style entry in both Traditional Chinese and English.',
        'Keep each explanation to 2–4 short sentences. Include part of speech when relevant.',
        'Respond with ONLY valid JSON (no markdown fences, no extra text) in this shape:',
        DICTIONARY_JSON_EXAMPLE,
    ].join('\n');
}

export function formatAiDictionaryEntry(parsed) {
    const chineseExplanation = (parsed?.chineseExplanation || parsed?.chinese || '').trim();
    const englishExplanation = (parsed?.englishExplanation || parsed?.english || '').trim();

    if (!chineseExplanation && !englishExplanation) {
        throw new Error('AI dictionary returned no explanation');
    }

    return { chineseExplanation, englishExplanation };
}

export async function fetchAiDictionaryExplanation(apiToken, text) {
    const trimmed = (text || '').trim();
    if (!trimmed) {
        throw new Error('No text selected');
    }
    if (!apiToken) {
        throw new Error('Please sign in to use AI Dictionary');
    }

    const response = await callDeepSeekApi(apiToken, '', buildAiDictionaryPrompt(trimmed), { jsonMode: true });

    if (response?.success === false) {
        throw new Error(response.message || 'AI Dictionary request failed');
    }

    const rawText = response?.output?.text;
    if (!rawText) {
        throw new Error('Empty AI Dictionary response');
    }

    const parsed = parseLlmJson(rawText);
    return formatAiDictionaryEntry(parsed);
}
